import React, { useState } from "react";
import "./Header.scss";
import LogoSvg from "../../../../../prod/images/logo-type.svg?react";
import MenuSvg from "../../../../../prod/images/menu.svg?react";
import SearchRedesignSvg from "../../../../../prod/images/redesign/search.svg?react";
import CrossSvg from "../../../../../prod/images/cross.svg?react";
import useMegaMenuMobileState from "./useMegaMenuMobileState";
import classNames from "classnames";
import { CatalogueHeaderData } from "../../../../api/headerApi.types";
import { ProductCatalogueMegaMenuMobile } from "./ProductCatalogueMegaMenuMobile";

interface ProductCatalogueHeaderMobileProps {
  headerModel: CatalogueHeaderData;
  frontPageUrl: string;
  frontPageTitle: string;
}

export const ProductCatalogueHeaderMobile: React.FC<
  ProductCatalogueHeaderMobileProps
> = ({ headerModel, frontPageUrl, frontPageTitle }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const {
    menuExpanded,
    searchExpanded,
    selectedMain,
    selectedSub,
    setMenuExpanded,
    setSearchExpanded,
    setSelectedMain,
    setSelectedSub,
  } = useMegaMenuMobileState();

  const handleMenuClick = (evt) => {
    evt.preventDefault();

    setSearchExpanded(false);
    // on menu close
    if (menuExpanded === true) {
      setSelectedSub(null);
      setSelectedMain(null);
    }
    setMenuExpanded((val) => !val);
  };

  const handleSearchIconClick = (evt) => {
    evt.preventDefault();

    setSearchExpanded((val) => !val);
  };

  const handleSearchSubmit = (evt) => {
    evt.preventDefault();

    if (searchExpanded) {
      const url = new URL(
        `${window.location.origin}/product-catalogue/search-results/`
      );
      url.searchParams.append("term", searchTerm);
      window.location.href = url.toString();
    }
  };

  const handleSearchInputChange = (evt) => {
    setSearchTerm(evt.target.value);
  };

  return (
    <div className="header-mobile">
      <div
        className={classNames(
          "header-top-mobile",
          menuExpanded ? "expanded" : ""
        )}
      >
        <a
          className="header-logo-mobile-container"
          href={frontPageUrl}
          title={frontPageTitle}
        >
          <span className="header-logo-mobile">
            <LogoSvg />
          </span>
          <span className="visually-hidden-accessible">{frontPageTitle}</span>
        </a>
        <div className="header-top-buttons-mobile">
          <button
            className="header-top-button-mobile"
            onClick={handleMenuClick}
          >
            {menuExpanded ? <CrossSvg /> : <MenuSvg />}
          </button>
          {!menuExpanded && (
            <button
              className="header-top-button-mobile"
              onClick={handleSearchIconClick}
            >
              {searchExpanded ? <CrossSvg /> : <SearchRedesignSvg />}
            </button>
          )}
        </div>
        {searchExpanded && (
          <form
            className="header-search-container-mobile"
            onSubmit={handleSearchSubmit}
          >
            <label htmlFor="globalSearch" className="invisible">
              {headerModel.searchAccessibilityText}
            </label>
            <div className="header-search-input-wrapper-mobile">
              <input
                className="header-serach-input-mobile"
                onChange={handleSearchInputChange}
                placeholder={headerModel.searchPlaceholderText}
              />
              <button className="header-top-button-mobile">
                <span className="visually-hidden-accessible">
                  {headerModel.searchAccessibilityText}
                </span>
                <SearchRedesignSvg />
              </button>
            </div>
          </form>
        )}
      </div>
      <ProductCatalogueMegaMenuMobile
        headerModel={headerModel}
        active={menuExpanded}
        selectedMain={selectedMain}
        selectedSub={selectedSub}
        setSelectedMain={setSelectedMain}
        setSelectedSub={setSelectedSub}
      />
    </div>
  );
};
